import Vue from "vue";
import Vuetify from "vuetify/lib";
import {colors} from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#47BD96",
        secondary: "#1C6E59",
        info: "#202125",
        accent: "#fff",
      },
      dark: {
        primary: "#47BD96",
        secondary: "#1C6E59",
        info: "#202125",
        accent: "#15151a",
      },
    },
    options: {variations: false}
  },
});
